function FileIcon({ width = 14, height = 11 }) {
    return (
        <svg
            width={`${width}`}
            height={`${height}`}
            viewBox="0 0 14 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.33333 10.6667C0.966667 10.6667 0.652889 10.5362 0.392 10.2753C0.131111 10.0144 0.000444444 9.70045 0 9.33333V1.33333C0 0.966667 0.130667 0.652889 0.392 0.392C0.653333 0.131111 0.967111 0.000444444 1.33333 0H5.33333L6.66667 1.33333H12C12.3667 1.33333 12.6807 1.464 12.942 1.72533C13.2033 1.98667 13.3338 2.30044 13.3333 2.66667V9.33333C13.3333 9.7 13.2029 10.014 12.942 10.2753C12.6811 10.5367 12.3671 10.6671 12 10.6667H1.33333ZM1.33333 9.33333H12V2.66667H6.11667L4.78333 1.33333H1.33333V9.33333Z"
                fill="#5D636F"
            />
        </svg>
    );
}

export default FileIcon;
